var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSingleSignOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 13.338a.74.74 0 0 1-.73.75.74.74 0 0 1-.729-.75.74.74 0 0 1 .73-.75.74.74 0 0 1 .73.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.698 15.955a2.85 2.85 0 0 1-1.427.382 2.88 2.88 0 0 1-2.214-1.045 3 3 0 1 1 4.918-3.35h5.17a.6.6 0 0 1 .42.17l.767.753a.6.6 0 0 1 .01.846l-1.386 1.426a.6.6 0 0 1-.855.006l-.513-.513-.717.575a.6.6 0 0 1-.715.027l-.67-.459h-1.572a3 3 0 0 1-1.216 1.182M9.3 15.4a2.1 2.1 0 0 0 2.046-1.627h2.264a.6.6 0 0 1 .34.105l.526.361.765-.613a.6.6 0 0 1 .8.043l.48.48.826-.849-.366-.359H11.37A2.1 2.1 0 1 0 9.3 15.4",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 14.574c0 .941.22 1.828.607 2.594h-.002c.395.864 1.119 1.573 2.077 1.573h14.624c.958 0 1.717-.756 2.092-1.573A5.7 5.7 0 0 0 22 14.574c0-2.704-1.822-4.924-4.145-5.154-1.259-2.47-3.621-4.16-6.31-4.16-2.944 0-5.282 1.535-6.426 4.4C3.307 10.34 2 12.282 2 14.573Zm18.036 2.594a4.27 4.27 0 0 0 .873-2.594c0-1.795-1.056-3.31-2.5-3.78-.352-.146-.703-.146-.945-.146a3 3 0 0 0-.276.012c-.967-2.451-3.13-4.158-5.643-4.158-2.53 0-4.705 1.73-5.662 4.209a3.24 3.24 0 0 0-1.362.677c-.867.715-1.43 1.875-1.43 3.186 0 .977.324 1.892.846 2.594.142.224.46.373.745.373h14.624c.285 0 .588-.15.73-.373",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSingleSignOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/single-sign-on.16f6f7bb.svg";